import React from "react";

import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import { twJoin } from "tailwind-merge";

import { Icon } from "src/design-system/Icon";

type WidgetContainerProps = {
  children: React.ReactNode;
  dataLoc?: string;
};

export const WidgetContainer: React.FC<WidgetContainerProps> = ({
  children,
  dataLoc,
}) => (
  <div
    className="overflow-hidden rounded-lg border border-gray-200 bg-white"
    data-loc={dataLoc}
  >
    {children}
  </div>
);

type WidgetHeaderRowProps = {
  children: React.ReactNode;
  rightSlot?: React.ReactNode;
};

export const WidgetHeaderRow: React.FC<WidgetHeaderRowProps> = ({
  children,
  rightSlot,
}) => (
  <div className="flex h-13 items-stretch gap-x-2 pl-4">
    {children}
    {rightSlot && <div className="flex shrink-0 items-center">{rightSlot}</div>}
  </div>
);

type WidgetTitleProps = {
  children: React.ReactNode;
};

export const WidgetTitle: React.FC<WidgetTitleProps> = ({ children }) => (
  <div className="min-w-0 flex-1 self-center font-inter-semibold-13px text-gray-800">
    {children}
  </div>
);

type WidgetChevronProps = {
  isOpen: boolean;
};

export const WidgetChevron: React.FC<WidgetChevronProps> = ({ isOpen }) => (
  <div
    className={twJoin(
      "flex h-5 w-5 shrink-0 items-center justify-center transition-transform duration-200",
      isOpen ? "rotate-0" : "-rotate-90",
    )}
  >
    <Icon icon={faChevronDown} size="xs" />
  </div>
);

type WidgetBodyProps = {
  children: React.ReactNode;
};

export const WidgetBody: React.FC<WidgetBodyProps> = ({ children }) => (
  <div className="border-gray-200 border-t">{children}</div>
);
